import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import translations from '@wix/wix-vod-shared/dist/src/common/i18n/translations';
import { getExperiments, experimentsFetched } from '../selectors/experiments';

function onLocaleLoad(func) {
  try {
    window.__Locale.onLoad(func);
  } catch (e) {
    func({
      locale: 'en',
      reactIntlData: [],
      translations: {},
    });
  }
}

onLocaleLoad(locale => {
  addLocaleData(locale.reactIntlData);
  translations.set(locale.translations);
});

@connect(state => ({
  experiments: getExperiments(state),
  experimentsFetched: experimentsFetched(state),
}))
export default class LocaleProvider extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    experiments: PropTypes.object,
    experimentsFetched: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      locale: null,
      translationsReady: false,
      experimentsReady: false,
    };
  }

  componentDidMount() {
    onLocaleLoad(({ locale }) =>
      this.setState({ locale, translationsReady: true }),
    );

    this.setExperiments();
  }

  componentDidUpdate() {
    this.setExperiments();
  }

  setExperiments = () => {
    if (!this.state.experimentsReady && this.props.experimentsFetched) {
      translations.setExperiments(this.props.experiments);
      this.setState({
        experimentsReady: true,
      });
    }
  };

  render() {
    const { locale, translationsReady } = this.state;
    const { children } = this.props;

    if (!translationsReady || !children) {
      return null;
    }

    return (
      <IntlProvider messages={translations.getAll()} locale={locale}>
        {children}
      </IntlProvider>
    );
  }
}
